import React from 'react';
import { audiences } from '../data/content';
export function AudienceSection() {
  return <section className="bg-white px-4 py-6 md:px-12 md:py-8" data-id="element-1" data-mp="n0yq9270sktt">
      <h2 className="mx-auto max-w-[600px] text-center font-heading text-[22px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[30px]" data-id="element-2" data-mp="n3kvgv6fuo8v">
        Designed for orthopedic &amp; trauma professionals
      </h2>
      <ul className="mt-4 divide-y divide-line border-y border-line" data-id="element-3" data-mp="3vhtizou3sou6">
        {audiences.map(a => <li key={a.title} className="grid gap-1 py-3 md:grid-cols-[240px_1fr] md:gap-6" data-id="element-4" data-mp="4a8o5fp9x220">
            <h3 className="font-heading text-[14px] font-extrabold uppercase leading-tight text-brand md:text-[15px]" data-id="element-5" data-mp="99lb00g5a94l">
              {a.title}
            </h3>
            <p className="text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-6" data-mp="e2wlcbk61819">{a.text}</p>
          </li>)}
      </ul>
    </section>;
}